export const formatPlanets = (cell: any) => {
  cell
    .getElement()
    .classList.remove('bg-info', 'bg-warning', 'bg-danger', 'bg-secondary');
  const dataCell = cell.getData();
  const planets = dataCell.planets / 1000000;
  if (dataCell.name === 'Mining') {
    let className = '';
    if (planets < 1500) {
      className = 'bg-danger';
    } else if (planets < 2500) {
      className = 'bg-warning';
    } else {
      className = 'bg-success';
    }
    cell.getElement().classList.add(className);
  }
  return planets;
};